import type { AxiosInstance } from 'axios';
import { SilentError } from 'init/silent-error';
import { z } from 'zod/v4';

import { handleZodError } from './utils';

const URL = '/cable_tickets';

const CableTicketSchema = z.object({
  ticket: z.string(),
});

export async function fetchCableTicket(axiosInstance: Promise<AxiosInstance>) {
  const instance = await axiosInstance;
  const { data } = await instance.post(URL);

  const parseResult = CableTicketSchema.safeParse(data);
  if (!parseResult.success) {
    handleZodError(parseResult, 'cableTicket');
    throw new SilentError();
  }

  return parseResult.data.ticket;
}
